
import { CheckCircle } from "lucide-react";

const FeaturesSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Nossa plataforma completa</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Gerencie todo o ciclo de energia solar da sua empresa em um único lugar
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="border border-gray-200 rounded-xl p-6 hover:shadow-md transition-all">
            <CheckCircle className="h-8 w-8 text-hero-blue mb-4" />
            <h3 className="text-xl font-semibold mb-3 text-gray-800">Monitoramento em Tempo Real</h3>
            <p className="text-gray-600">
              Acompanhe a geração de energia, economia e desempenho do sistema através de dashboards intuitivos.
            </p>
          </div>
          
          <div className="border border-gray-200 rounded-xl p-6 hover:shadow-md transition-all">
            <CheckCircle className="h-8 w-8 text-hero-green mb-4" />
            <h3 className="text-xl font-semibold mb-3 text-gray-800">Gestão Financeira Integrada</h3>
            <p className="text-gray-600">
              Controle investimentos, retorno financeiro e cálculos de economia em uma interface centralizada.
            </p>
          </div>
          
          <div className="border border-gray-200 rounded-xl p-6 hover:shadow-md transition-all">
            <CheckCircle className="h-8 w-8 text-highlight-yellow mb-4" />
            <h3 className="text-xl font-semibold mb-3 text-gray-800">Suporte Técnico Especializado</h3>
            <p className="text-gray-600">
              Conte com uma equipe de especialistas para maximizar o desempenho do seu sistema solar.
            </p>
          </div>
          
          <div className="border border-gray-200 rounded-xl p-6 hover:shadow-md transition-all">
            <CheckCircle className="h-8 w-8 text-hero-blue mb-4" />
            <h3 className="text-xl font-semibold mb-3 text-gray-800">Calculadora de Viabilidade</h3>
            <p className="text-gray-600">
              Faça simulações personalizadas baseadas no consumo real da sua empresa e localização geográfica.
            </p>
          </div>
          
          <div className="border border-gray-200 rounded-xl p-6 hover:shadow-md transition-all">
            <CheckCircle className="h-8 w-8 text-hero-green mb-4" />
            <h3 className="text-xl font-semibold mb-3 text-gray-800">Gestão de Projetos</h3>
            <p className="text-gray-600">
              Acompanhe todo o ciclo de implementação, desde o projeto até a instalação e manutenção.
            </p>
          </div>
          
          <div className="border border-gray-200 rounded-xl p-6 hover:shadow-md transition-all">
            <CheckCircle className="h-8 w-8 text-highlight-yellow mb-4" />
            <h3 className="text-xl font-semibold mb-3 text-gray-800">Relatórios e Análises</h3>
            <p className="text-gray-600">
              Gere relatórios detalhados e obtenha insights para otimizar ainda mais seu sistema.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
